import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../Assets/image.png";
import Tilt from "react-parallax-tilt";
import ResumeModal from "../Resume/ResumeModal";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineDownload,
  AiOutlineCode,
  AiOutlineMobile,
  AiOutlineGlobal,
  AiOutlineApi,
  AiOutlineCloudServer,
  AiOutlineBulb,
  AiOutlineUser,
  AiOutlineTool,
  AiOutlineLineChart,
} from "react-icons/ai";
import { FaLinkedinIn, FaReact, FaNodeJs, FaDatabase, FaGitAlt, FaPalette, FaAws } from "react-icons/fa";
import {
  SiFlutter,
  SiMongodb,
  SiExpress,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiNestjs,
  SiNextdotjs,
  SiFirebase,
  SiVisualstudiocode,
  SiPostman,
  SiAndroidstudio,
  SiGit,
  SiGithub,
  SiFigma,
  SiNotion,
  SiSlack,
  SiVercel,
  SiNetlify,
  SiSwagger,
  SiPostgresql,
  SiGrafana,
  SiRender
} from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
import { DiJavascript1, DiReact, DiNodejs, DiMongodb } from "react-icons/di";
import { ImPointRight } from "react-icons/im";

function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [typedText, setTypedText] = useState("");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const fullText = "Full-Stack Developer & Mobile App Creator";

  useEffect(() => {
    setIsVisible(true);

    // Typewriter effect for subtitle
    let index = 0;
    const typeInterval = setInterval(() => {
      if (index < fullText.length) {
        setTypedText(fullText.slice(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
      }
    }, 100);

    return () => clearInterval(typeInterval);
  }, []);

  const techStack = [
    { icon: <FaReact />, name: "React.js", color: "#61DAFB" },
    { icon: <SiNextdotjs />, name: "Next.js", color: "#000000" },
    { icon: <FaNodeJs />, name: "Node.js", color: "#339933" },
    { icon: <SiNestjs />, name: "NestJS", color: "#E0234E" },
    { icon: <SiExpress />, name: "Express.js", color: "#000000" },
    { icon: <SiMongodb />, name: "MongoDB", color: "#47A248" },
    { icon: <SiPostgresql />, name: "PostgreSQL", color: "#4169E1" },
    { icon: <SiJavascript />, name: "JavaScript", color: "#F7DF1E" },
    { icon: <SiFlutter />, name: "Flutter", color: "#02569B" },
    { icon: <TbBrandReactNative />, name: "React Native", color: "#61DAFB" },
    { icon: <SiFirebase />, name: "Firebase", color: "#FFCA28" },
  ];

  const toolStack = [
    { icon: <SiVisualstudiocode />, name: "VS Code", color: "#007ACC" },
    { icon: <SiPostman />, name: "Postman", color: "#FF6C37" },
    { icon: <SiAndroidstudio />, name: "Android Studio", color: "#3DDC84" },
    { icon: <SiGithub />, name: "GitHub", color: "#181717" },
    { icon: <SiFigma />, name: "Figma", color: "#F24E1E" },
    { icon: <SiNotion />, name: "Notion", color: "#000000" },
    { icon: <SiSlack />, name: "Slack", color: "#4A154B" },
    { icon: <SiVercel />, name: "Vercel", color: "#000000" },
    { icon: <SiNetlify />, name: "Netlify", color: "#00C7B7" },
    { icon: <SiFirebase />, name: "Firebase", color: "#FFCA28" },
    { icon: <SiSwagger />, name: "Swagger", color: "#85EA2D" },
    { icon: <FaAws />, name: "AWS", color: "#FF9900" },
    { icon: <SiRender />, name: "Render", color: "#46E3B7" },
    { icon: <SiGrafana />, name: "Grafana", color: "#F46800" },
    { icon: <AiOutlineLineChart />, name: "Langfuse", color: "#8B5CF6" },
  ];

  const stats = [
    { number: "4+", label: "Years Experience" },
    { number: "15+", label: "Projects Completed" },
    { number: "5+", label: "Technologies Mastered" },
  ];

  return (
    <section>
      {/* Hero Section */}
      <Container fluid className="home-hero-section" id="home">
        <div className="hero-particles"></div>
        <Container className="h-100">
          <Row className="align-items-center justify-content-center min-vh-100">
            <Col lg={7} md={1} className={`hero-content ${isVisible ? 'fade-in' : ''}`}>


              <div className="hero-subtitle">
                <span className="greeting-text">👋 Hello, I'm Yamini Chaudhary</span>
                <br />
                <span className="typewriter">{typedText}</span>
                <span className="cursor">|</span>
              </div>

              <p className="hero-description">
                Passionate about crafting <span className="highlight">innovative digital experiences</span> through
                clean code and creative problem-solving. I specialize in building scalable web applications
                and beautiful mobile apps that make a difference.
              </p>

              <div className="hero-buttons">
                <Button as={Link} to="/project" className="cta-button primary">
                  <AiOutlineCode className="me-2" />
                  View My Work
                </Button>
                <Button 
                  onClick={() => setShowResumeModal(true)} 
                  className="cta-button secondary"
                >
                  <AiOutlineDownload className="me-2" />
                 My Resume
                </Button>
              </div>
            </Col>

            <Col lg={5} md={12} className="hero-visual">
              <div className="hero-card">
                <div className="floating-elements">
                  <div className="floating-icon web"><AiOutlineGlobal /></div>
                  <div className="floating-icon mobile"><AiOutlineMobile /></div>
                  <div className="floating-icon code"><AiOutlineCode /></div>
                  <div className="floating-icon react"><FaReact /></div>
                  <div className="floating-icon database"><FaDatabase /></div>
                  <div className="floating-icon api"><AiOutlineApi /></div>
                  <div className="floating-icon git"><FaGitAlt /></div>
                  <div className="floating-icon cloud"><AiOutlineCloudServer /></div>
                  <div className="floating-icon design"><FaPalette /></div>
                  <div className="floating-icon idea"><AiOutlineBulb /></div>
                </div>

                <Tilt className="hero-tilt">
                  <div className="hero-avatar">
                    <img src={logo} alt="Yamini Chaudhary" className="avatar-img" />
                    <div className="avatar-glow"></div>
                  </div>
                </Tilt>

                <div className="status-indicator">
                  <div className="status-dot"></div>
                  <span>Available for opportunities</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Tech Stack Section */}
      <Container fluid className="tech-showcase-section">
            <Col md={12} className="text-center mb-5">
              <h2 className="section-title">Technologies I Work With</h2>
                <p className="section-subtitle">
                Building modern solutions with cutting-edge technologies
                </p>
                <Row className="mt-5 justify-content-center">
            {techStack.map((tech, index) => (
              <Col key={index} xs={6} sm={4} md={2} className="tech-item-col">
                <div className="tech-item" style={{ '--tech-color': tech.color }}>
                  <div className="tech-icon">{tech.icon}</div>
                  <span className="tech-name">{tech.name}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
            </Col>
        </Container>
         {/* Tools Stack */}
        <Container fluid className="tool-showcase-section">
            <Col md={12} className="text-center mb-5">
              <h2 className="section-title">Tools I Use</h2>

                <Row className="mt-5 justify-content-center">
            {toolStack.map((tool, index) => (
              <Col key={index} xs={6} sm={4} md={2} className="tech-item-col">
                <div className="tech-item" style={{ '--tech-color': tool.color }}>
                  <div className="tech-icon">{tool.icon}</div>
                  <span className="tech-name">{tool.name}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
            </Col>
        </Container>

      {/* Stats Section */}
      <Container fluid className="stats-section">
        <Container>
          <Row>
            {stats.map((stat, index) => (
              <Col key={index} md={4} className="stat-col">
                <div className="stat-card">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>

      {/* Social & Contact Section */}
      <Container fluid className="social-section">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h2 className="social-title">Let's Connect & Create</h2>
              <p className="social-subtitle">
                Ready to bring your ideas to life? Let's start a conversation!
              </p>

              <div className="social-links">
                <a
                  href="https://github.com/yamini-chaudhary"
                  target="_blank"
                  rel="noreferrer"
                  className="social-link github"
                  aria-label="GitHub Profile"
                >
                  <AiFillGithub />
                  <span>GitHub</span>
                </a>

                <a
                  href="https://www.linkedin.com/in/yamini-chaudhary-839a42217"
                  target="_blank"
                  rel="noreferrer"
                  className="social-link linkedin"
                  aria-label="LinkedIn Profile"
                >
                  <FaLinkedinIn />
                  <span>LinkedIn</span>
                </a>

                <a
                  href="https://www.instagram.com/yamini.0909"
                  target="_blank"
                  rel="noreferrer"
                  className="social-link instagram"
                  aria-label="Instagram Profile"
                >
                  <AiFillInstagram />
                  <span>Instagram</span>
                </a>
              </div>

              <div className="contact-cta">
                <Button className="contact-button" href="mailto:yamini.chaudhary@example.com">
                  Get In Touch
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      
      {/* Resume Modal */}
      <ResumeModal 
        show={showResumeModal} 
        onHide={() => setShowResumeModal(false)} 
      />
    </section>
  );
}

export default Home;
